<div class="ai-assistant-settings-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'AI_ASSISTANT.SETTINGS.DESCRIPTION' | translate }}
    </p>

    @if (initialLoadFailed() && loadError(); as error) {
      <tf-settings-load-error
        [title]="error.text"
        [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
        [details]="loadErrorDetails()"
        [retrying]="isLoading()"
        (retry)="retryLoad()" />
    } @else if (!hasLoadedOnce()) {
      <div class="ai-assistant-settings-skeleton" aria-hidden="true">
        <section class="ai-assistant-settings-skeleton__card">
          <span
            class="ai-assistant-settings-skeleton__bar ai-assistant-settings-skeleton__bar--title"></span>
          <span class="ai-assistant-settings-skeleton__control"></span>
          <span
            class="ai-assistant-settings-skeleton__bar ai-assistant-settings-skeleton__bar--text"></span>
          <span
            class="ai-assistant-settings-skeleton__bar ai-assistant-settings-skeleton__bar--text-short"></span>
          <span
            class="ai-assistant-settings-skeleton__bar ai-assistant-settings-skeleton__bar--text-shorter"></span>
        </section>
      </div>
    } @else {
      <tf-settings-inline-message
        [message]="saveError()"
        messageId="ai-assistant-settings-save-error"
        (dismissed)="clearSaveError()" />

      <div class="settings-page__field">
        <label for="ai-assistant-mode" class="settings-page__label">
          {{ 'AI_ASSISTANT.SETTINGS.MODE_LABEL' | translate }}
        </label>
        <div class="settings-page__field-input-wrap">
          <p-select
            inputId="ai-assistant-mode"
            [options]="modeOptions()"
            [ngModel]="selectedMode()"
            (ngModelChange)="onModeChange($event)"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full"
            [disabled]="!canUpdateAiAssistant() || !settings()"
            [attr.aria-describedby]="saveError() ? 'ai-assistant-settings-save-error' : null" />
        </div>
        <p class="settings-page__description ai-assistant-mode-help-intro">
          {{ 'AI_ASSISTANT.SETTINGS.MODE_HELP_INTRO' | translate }}
        </p>
        <ul class="ai-assistant-mode-help-list">
          <li>{{ 'AI_ASSISTANT.SETTINGS.MODE_HELP_OFF' | translate }}</li>
          <li>{{ 'AI_ASSISTANT.SETTINGS.MODE_HELP_READ_ONLY' | translate }}</li>
          <li>{{ 'AI_ASSISTANT.SETTINGS.MODE_HELP_READ_WRITE' | translate }}</li>
        </ul>
      </div>
    }
  </div>

  @if (hasLoadedOnce() && !initialLoadFailed()) {
    <tf-settings-actions
      (cancelled)="cancel()"
      (save)="save()"
      [disabled]="isLoading() || isSaving() || !settings() || !canUpdateAiAssistant()"
      [loading]="isSaving()" />
  }
</div>
